import { useRouter } from 'next/router';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { AboutSectionContainer, ImageWrapper } from './style';

import Image from '@components/atoms/image';
import { useUniversityInformation } from '@helpers/use';
import { getAssetUrl, sanitize } from '@helpers/utils';

export const AboutSection = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const universityIdName = router.query.universityIdName as string;
  const { landingPage } = useUniversityInformation(universityIdName);

  return (
    <AboutSectionContainer>
      <ImageWrapper>
        <Image
          src={landingPage?.aboutSkilllaneImageUrl || ''}
          alt="About"
          errorImage={`${getAssetUrl('thumbnail-course-card.jpg')}`}
        />
      </ImageWrapper>
      <Box flex={1} display="flex" flexDirection="column" justifyContent="center">
        <Typography marginBottom={1} fontSize="24px" fontWeight={500} lineHeight={1} color="#00000099">
          {t('academic_landing_page.about_section.heading')}
        </Typography>
        <Typography marginBottom={2} fontSize="30px" fontWeight={700} lineHeight="34px" color="#000000de">
          {landingPage?.aboutSkilllaneSectionHeading}
        </Typography>
        <Typography variant="body2_deprecated" color="#00000099">
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={sanitize(landingPage?.aboutSkilllaneDescription || '')}
          />
        </Typography>
      </Box>
    </AboutSectionContainer>
  );
};
